import {
  DIGIDIARY_ADD_FARM,
  DIGIDIARY_RESET_ALERT,
  DIGIDIARY_SET_LOADER,
  DIGIDIARY_GET_EXPENSE,
  DIGIDIARY_ADD_EQUIPMENT,
  DD_LOAD_MY_FARM_VIEW,
  DD_UPDATE_CROP_DETAILS,
  DD_ADD_NEW_CROP,
  DD_UPDATE_IMPLEMENTS_DETAILS,
  SET_UP_HOME_PAGE,
  ADD_CYCLE_ACTIVITY,
  DIGIDIARY_ADD_YIELD,
  DIGIDIARY_GET_YIELD,
  DIGIDIARY_ADD_INCOME,
  DIGIDIARY_GET_INCOME,
  DIGIDIARY_INCOME_TIMESTAMP,
  DIGIDIARY_RESET_INCOME_TIMESTAMP,
  SET_ACTIVITY_MODAL,
  DIGIDIARY_ADD_EDIT_EXPENSE,
  DIGIDIARY_SET_API_ERROR,
  DIGIDIARY_RESET_EQUIPMENT_TYPE,
  DIGIDIARY_TNC_ACCEPTED,
  UPDATE_DD_TNC_ACCEPTED,
} from './actionTypes';

export const addFarmDetails = (redirectView) => {
  return {
    type: DIGIDIARY_ADD_FARM,
    redirectView,
  };
};

export const loadHomePageDataAction = () => {
  return {
    type: SET_UP_HOME_PAGE,
  };
};

export const getExpenseDetails = () => {
  return {
    type: DIGIDIARY_GET_EXPENSE,
  };
};

export const showLoader = (flag) => {
  return {
    type: DIGIDIARY_SET_LOADER,
    flag,
  };
};

export const resetAlert = () => {
  return {
    type: DIGIDIARY_RESET_ALERT,
  };
};

export const addEquipment = (data) => {
  return {
    type: DIGIDIARY_ADD_EQUIPMENT,
    data,
  };
};

export const updateCropDetails = (data) => {
  return {
    type: DD_UPDATE_CROP_DETAILS,
    data,
  };
};

export const updateImplementsDetails = (data) => {
  return {
    type: DD_UPDATE_IMPLEMENTS_DETAILS,
    data,
  };
};

export const addNewCrop = (data) => {
  return {
    type: DD_ADD_NEW_CROP,
    data,
  };
};

export const addExpenseAction = (data) => {
  return {
    type: DIGIDIARY_ADD_EDIT_EXPENSE,
    data,
  };
};

export const addCycleActivity = (data) => {
  return {
    type: ADD_CYCLE_ACTIVITY,
    data,
  };
};
export const loadMyFarmViewAction = () => {
  return {
    type: DD_LOAD_MY_FARM_VIEW,
  };
};
export const updateTimestamp = (data) => {
  return {
    type: DIGIDIARY_INCOME_TIMESTAMP,
    data,
  };
};
export const resetIncomeTimestamp = () => {
  return {
    type: DIGIDIARY_RESET_INCOME_TIMESTAMP,
  };
};
export const addYieldAPIAction = (data) => {
  return {
    type: DIGIDIARY_ADD_YIELD,
    data,
  };
};
export const getYieldAPIAction = () => {
  return {
    type: DIGIDIARY_GET_YIELD,
  };
};
export const addIncomeAPIAction = (data) => {
  return {
    type: DIGIDIARY_ADD_INCOME,
    data,
  };
};
export const getIncomeAPIAction = (data) => {
  return {
    type: DIGIDIARY_GET_INCOME,
    data,
  };
};

export const setActivityModalAction = (flag) => {
  return {
    type: SET_ACTIVITY_MODAL,
    flag,
  };
};

export const setApiErrorAction = (error) => {
  return {
    type: DIGIDIARY_SET_API_ERROR,
    error,
  };
};
export const resetEquipmentTypeAction = () => {
  return {
    type: DIGIDIARY_RESET_EQUIPMENT_TYPE,
  };
};

export const ddTnCAcceptedAction = (redirectView) => {
  return {
    type: DIGIDIARY_TNC_ACCEPTED,
    redirectView,
  };
};

export const updateDDCustomerTnCAcceptedAction = () => {
  return {
    type: UPDATE_DD_TNC_ACCEPTED,
  };
};
